import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { DomSanitizer, SafeResourceUrl, Title } from '@angular/platform-browser';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';

const GRAFANA_URL =
  'https://goul.org/grafana/d/adc9gdz/notesapp-error-logs?orgId=1&from=now-24h&to=now&timezone=browser&theme=light&kiosk';

@Component({
  selector: 'app-notesapp-error-report',
  standalone: true,
  imports: [CommonModule, ButtonModule, CardModule],
  templateUrl: './notesapp-error-report.component.html',
  styleUrls: ['./notesapp-error-report.component.css'],
})
export class NotesappErrorReportComponent {
  readonly grafanaUrl: SafeResourceUrl;

  constructor(private router: Router, sanitizer: DomSanitizer, titleService: Title) {
    this.grafanaUrl = sanitizer.bypassSecurityTrustResourceUrl(GRAFANA_URL);
    titleService.setTitle('NotesApp Error Logs');
  }

  close(): void {
    this.router.navigate(['/home']);
  }
}
